<script>
import { DeviceSettingsForm, WifiForm } from '@midulate/shared';

export default {
  name: "Settings",

  // RouterView passes connectedDevice and other props to all route components
  // generically; suppress fallthrough to avoid Vue attribute warnings.
  inheritAttrs: false,

  components: {
    DeviceSettingsForm,
    WifiForm,
  },

  props: {
    capabilities: {
      type: Object,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    connectedDevice: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      wifiStatus: null,
    };
  },

  async mounted() {
    if (this.connectedDevice) {
      try {
        this.wifiStatus = await this.connectedDevice.getWifiStatus();
      } catch (e) {
        // Status unavailable — leave as null (UI handles gracefully)
        console.warn('GET_WIFI_STATUS failed:', e);
      }
    }
  },
}
</script>
<template>
  <div>
    <DeviceSettingsForm :settings="config.settings" />
    <div class="divider"></div>
    <WifiForm v-model:wifiStatus="wifiStatus" :settings="config.settings" :connectedDevice="connectedDevice" />
  </div>
</template>
